export default{
  setUser(state, payload) {
    state.token = payload.token;
    state.userId = payload.userId;
    state.didAutoLogout = false;
    },
  setPointLogs(state, payload) {
    state.pointLogs = payload;
  },
  setRewardLogs(state, payload) {
    state.rewardLogs = payload;
  },
  setRewardTotal(state, payload) {
    state.rewardTotal = payload;
  },
};
